import { config } from "config";
import { SetDeliveryBranchesPayload, DeliveryBranchState } from ".";
import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { SelectOption } from "components/atoms/Select";

const default_page_size = config.PAGE_SIZE;
const initialState: DeliveryBranchState = {
  deliveryBranches: [],
  deliveryBranch: null,
  loading: true,
  deliveryBranchOptions: [],
  deliveryBranchOptionsCount: 0,
  current_filters: {},
  filters: { page: 1, pageSize: default_page_size },
  refresh: 0,
  refreshLoader: false,
  totalCount: 0,
};

export const deliveryBranchSlice = createSlice({
  name: "deliveryBranch",
  initialState,
  reducers: {
    clear: (state) => {
      state.deliveryBranchOptions = [];
    },
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.loading = action.payload;
    },
    addDeliveryBranch: (state, action) => {
      state.deliveryBranches.unshift(action.payload);
    },
    updateDeliveryBranch: (state, action) => {
      const { id, deliveryBranch } = action.payload;
      state.deliveryBranches.every(({ _id }, i) => {
        if (id === _id) {
          state.deliveryBranches[i] = deliveryBranch;
          return false;
        }
        return true;
      });
    },
    deleteDeliveryBranchById: (state, action) => {
      const id = action.payload;
      state.deliveryBranches.every(({ _id }, i) => {
        if (id === _id) {
          state.totalCount -= 1;
          state.deliveryBranches.splice(i, 1);
          return false;
        }
        return true;
      });
    },
    setDeliveryBranch: (state, action) => {
      state.deliveryBranch = action.payload;
    },
    setDeliveryBranches: (
      state,
      action: PayloadAction<SetDeliveryBranchesPayload>
    ) => {
      const { totalCount, deliveryBranches } = action.payload;
      state.totalCount = totalCount;
      state.deliveryBranches = deliveryBranches;
      state.refreshLoader = false;
    },
    setTotalCount: (state, action: PayloadAction<any>) => {
      const { totalCount } = action.payload;
      state.totalCount = totalCount;
    },

    setDeliveryBranchOptions: (
      state,
      action: PayloadAction<SelectOption[]>
    ) => {
      state.deliveryBranchOptions = action.payload;
    },
    setDeliveryBranchOptionsCount: (state, action: PayloadAction<number>) => {
      state.deliveryBranchOptionsCount = action.payload;
    },
    setDeliveryBranchOptionsPage: (state, action: PayloadAction<number>) => {
      state.filters.page = action.payload;
    },
    setDeliveryBranchOptionsSearch: (state, action: PayloadAction<string>) => {
      state.filters.search = action.payload;
      state.filters.page = 1; // Reset to first page when searching
    },
    resetDeliveryBranchOptionsFilters: (state) => {
      state.filters = initialState.filters;
    },
    setPage: (state, action: PayloadAction<number>) => {
      state.filters.page = action.payload;
    },
    resetPage: (state) => {
      state.filters.page = 1;
    },
    setFilters: (state, action) => {
      state.filters = action.payload;
      state.refreshLoader = true;
    },
    setCurrentFilters: (state, action) => {
      state.current_filters = action.payload;
    },
    resetFilters: (state) => {
      state.filters = initialState.filters;
      state.current_filters = initialState.current_filters;
    },
  },
});

const deliveryBranchReducer = deliveryBranchSlice.reducer;

export const deliveryBranchActions = deliveryBranchSlice.actions;
export default deliveryBranchReducer;
